export default __webpack_public_path__ + "static/media/home-nft.1a22bc68.png";